import React from "react";
import { toast } from "react-toastify";
import { Button, DynamicDropdown } from "src/Components";
import TextInput from "src/Components/TextInput";
import { ICustomerReportScopeUpsertFormValues } from "src/Interfaces/reportLinks";
import { getUsers } from "src/Requests/imePortfolio";
import { upsertCustomerReportScope } from "src/Requests/reportLinksRequests";
import { packetErrorHandler } from "src/Utils/requestUtils";
import * as R from "ramda";

interface IProps {
  editValues?: ICustomerReportScopeUpsertFormValues;
  accountName?: string;
  onClose: () => void;
  onSuccess: () => void;
}

const UpsertModal: React.FC<IProps> = ({
  editValues,
  accountName,
  onClose,
  onSuccess,
}) => {
  console.log(accountName);
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] =
    React.useState<ICustomerReportScopeUpsertFormValues>(
      editValues ?? {
        accountId: 0,
        accessLink: "",
        username: "",
        password: "",
        shownName: "",
      },
    );

  const changeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const submitHandler = () => {
    setLoading(true);
    upsertCustomerReportScope({
      ...formValues,
      id: editValues?.id ?? null,
    })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const preventAutofillOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.readOnly = false;
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-72">
      {!editValues ? (
        <DynamicDropdown
          dropdown={{
            name: "accountId",
            placeholder: "اکانت",
            extraLabel: true,
          }}
          value={
            formValues.accountId ? String(formValues.accountId) : undefined
          }
          getData={() => getUsers()}
          onChange={(name, value) =>
            changeHandler(name, value ? Number(value) : null)
          }
        />
      ) : (
        <TextInput
          label="اکانت"
          name="accountName"
          extraLabel
          value={accountName}
          disabled={true}
          onChange={(name, value) => changeHandler(name, Number(value))}
        />
      )}
      <TextInput
        label="نام کاربری"
        name="username"
        value={formValues.username}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="نام نمایشی"
        name="shownName"
        value={formValues.shownName}
        onChange={changeHandler}
        extraLabel
      />
      {editValues ? null : (
        <TextInput
          label="رمز عبور"
          name="password"
          type="password"
          value={formValues.password}
          onChange={changeHandler}
          extraLabel
          autoComplete="new-password"
          readOnly
          onFocus={preventAutofillOnFocus}
        />
      )}
      <div className="w-full self-center mt-4">
        <Button
          text={editValues ? "ویرایش" : "اضافه کردن"}
          onClick={submitHandler}
          variant="contained"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default UpsertModal;
